<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-batch-tracing-spec-detail class="flex" [spec]="spec" (close)="onClose($event)">
  </app-batch-tracing-spec-detail>
</div>
